module.exports = __webpack_public_path__ + "images/ef9eb037523db8a3a23e4749232d1356.png";